module.exports = __webpack_public_path__ + "img/dp5.126b0042.png";